<template>
  <div class="gpt-chart-aiops-container">
    <span style="font-size: 16px;">点击<a @click="generateReport">此处</a>生成报告</span>
    <a-modal v-model="visible" title="故障诊断记录" :footer="null" :width="900">
        <a-descriptions :title="null" bordered :column="2" class="gpt-aiops-descriptions">
            <a-descriptions-item v-for="item in basicArr" :label="item.title" :key="item.title" :span="item.span">
              {{ item.value }}
            </a-descriptions-item>
        </a-descriptions>
    </a-modal>
  </div>
</template>

<script>
export default {
    name: 'gpt-chart-aiops',
    data () {
        return {
            visible: false,
            fieldNameMap: {
                majorName: { title: '专业名称', span: 1, isBasic: true, value: 'PSD站台门' },
                equipName: { title: '设备名称', span: 1, isBasic: true, value: '站台门' },
                startTime: { title: '处理开始时间:', span: 1, isBasic: true, value: '-' },
                endTime: { title: '处理结束时间:', span: 1, isBasic: true, value: '-' },
                malPhenomenon: { title: '故障现象描述:', span: 2, isBasic: true, value: '整侧站台门无关闭且锁紧信号故障' },
                diagnosticProcess: { title: '诊断过程:', span: 2, isBasic: true, value: '检查所有滑动门、应急门已关闭到位， 门头灯无闪烁及常亮现象，锁紧信号的输出、输入电压均为24V，安全回路继电器触点异常。' },
                cause: { title: '故障原因:', span: 2, isBasic: true, value: '安全回路继电器触点异常' },
                method: { title: '解决措施:', span: 2, isBasic: true, value: '更换继电器触点后，恢复正常' },
                handleTime: { title: '处理时长:', span: 1, isBasic: true, value: '30分' }
            },
            basicArr: []
        };
    },
    props: {
        value: {
            type: Object,
            default: function () {
                return {};
            }
        }
    },
    watch: {
        value: function () {
            this.basicArr = [];
            const keys = Object.keys(this.value);
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                if (this.value[key].isBasic) {
                    const value = this.value[key];
                    this.basicArr.push({ title: this.fieldNameMap[key].title, value: value || '-', span: this.fieldNameMap[key].span, isUrl: this.fieldNameMap[key].isUrl });
                }
            }
        }
    },
    mounted () {
        const keys = Object.keys(this.fieldNameMap);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (this.fieldNameMap[key].isBasic) {
                const value = this.value[key] || this.fieldNameMap[key].value;
                this.basicArr.push({ title: this.fieldNameMap[key].title, value: value || '-', span: this.fieldNameMap[key].span });
            }
        }
    },
    methods: {
        generateReport () {
            this.visible = true;
        }
    }
};
</script>
<style scoped lang="scss">
.gpt-aiops-descriptions {
    ::v-deep .ant-descriptions-item-label{
        width: 160px;
    }
}
</style>
